module.exports = __webpack_public_path__ + "img/team.1bf0d210.svg";